import { render, staticRenderFns } from "./pay-check.vue?vue&type=template&id=f9ce48de"
import script from "./pay-check.vue?vue&type=script&lang=js"
export * from "./pay-check.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports